export default __webpack_public_path__ + "static/media/7.90e073c2.webp";